<template>
  <div class="game-config">
    <div class="action-part">
      <el-form :inline="true" size="medium">
        <el-form-item>
          <el-button type="primary" @click="showEditor(null)">创建配置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="showImportEditor(null)">导入配置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="showConfigPreview(null)">预览配置</el-button>
        </el-form-item>
        <el-form-item>
                    <span style="margin-left: 20px;font-size: 22px;">当前配置游戏：(<span
                        style="color: red">{{ gameName }}</span>)
                    </span>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-list">
      <el-table
          border
          :data="resultList"
          style="width: 100%">
        <el-table-column
            prop="name"
            width="200"
            label="名字">
        </el-table-column>
        <el-table-column
            prop="type"
            width="100"
            label="类型">
        </el-table-column>
        <el-table-column
            prop="source"
            label="资源">
        </el-table-column>
        <el-table-column
            align="center"
            width="200"
            prop="createTime"
            label="创建时间">
        </el-table-column>
        <el-table-column
            width="200"
            align="right"
            label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row)"
                icon-color="red"
                title="确定删除该游戏配置吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-part">
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="dialogText"
          center
          :visible.sync="isEditorShow"
          width="500px">
        <div class="editor-content">
          <el-form size="medium" label-width="100px">
<!--            <el-form-item label="模块" :required="true">-->
<!--              <el-cascader-->
<!--                  clearable-->
<!--                  v-model="selectModuleIds"-->
<!--                  :options="appModuleTreeData"-->
<!--                  :props="{ checkStrictly: true, value: 'id', label: 'name' }"-->
<!--                  :show-all-levels="true"-->
<!--                  @change="() => {}" placeholder="请选择数据的模块"></el-cascader>-->
<!--            </el-form-item>-->
            <el-form-item label="配置名" required>
              <el-input v-model="gameConfig.name" placeholder="请输入配置名称，要与游戏内一致."></el-input>
            </el-form-item>
            <el-form-item label="类型" required>
              <el-select v-model="gameConfig.type">
                <el-option value="image" label="图片"></el-option>
                <el-option value="mp3" label="音频"></el-option>
                <el-option value="mp4" label="视频"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="音频文件" :required="true" v-if="gameConfig.type==='mp3'">
              <el-upload
                  :show-file-list="false"
                  :http-request="uploadMp3"
                  accept=".mp3"
                  action=""
                  :limit="1">
                <el-button size="small" type="primary">上传音频</el-button>
                <div slot="tip" class="el-upload__tip">只能上传.mp3文件，且不超过10M</div>
              </el-upload>
            </el-form-item>
            <el-form-item
                label="图片" :required="true" v-if="gameConfig.type==='image'">
              <div class="form-item-container">
                <el-upload
                    accept="image/jpeg,image/png,image/jpg"
                    :show-file-list="false"
                    action=""
                    :http-request="uploadImage">
                  <div class="video-image-upload-cover image-upload-cover">
                    <img v-if="gameConfig.source" :src="gameConfig.source" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                </el-upload>
              </div>
              <div class="form-des-text">
                支持JPEG/PNG，不超过2M
              </div>
            </el-form-item>
            <el-form-item
                label="视频" :required="true" v-if="gameConfig.type==='mp4'">
              <div class="form-item-container">
                <el-upload
                    accept="video/mp4"
                    :show-file-list="false"
                    action=""
                    :http-request="uploadVideo">
                  <el-button type="primary">上传视频</el-button>
                </el-upload>
              </div>
              <div class="form-des-text">
                MP4格式，大小不超过100M
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-action" solt="footer" style="text-align: center">
          <el-button size="medium" @click="onEditorCancel">取 消</el-button>
          <el-button type="primary" size="medium" @click="onEditorConfirm">提 交</el-button>
        </div>
      </el-dialog>
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          title="导入配置"
          center
          :visible.sync="isImportEditorShow"
          width="500px">
        <div class="editor-content">
          <el-form size="medium" label-width="100px">
            <el-form-item label="配置内容" required>
              <el-input type="textarea" rows="20" resize="none" v-model="gameImportConfig.configJson"
                        :placeholder="configJsonTemplate"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="dialog-action" solt="footer" style="text-align: center">
          <el-button size="medium" @click="onImportEditorCancel">取 消</el-button>
          <el-button type="primary" size="medium" @click="onImportEditorConfirm">提 交</el-button>
        </div>
      </el-dialog>
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          title="配置预览"
          center
          :visible.sync="isPreViewEditorShow"
          width="1000px">
        <div class="editor-content">
          <el-input type="textarea" rows="20" resize="none" v-model="previewJson"></el-input>
        </div>
        <div class="dialog-action" solt="footer" style="text-align: center;margin-top: 20px;">
          <el-button size="medium" @click="onPreviewEditorCancel">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'

export default {
  data() {
    return {
      isPreViewEditorShow: false,
      isImportEditorShow: false,
      dialogText: '',
      search: {
        name: '',
        label: ''
      },
      isEditorShow: false,
      gameConfig: {
        name: '',
        type: '',
        source: '',
        id: '',
        gameId: '',
        moduleId: '0'
      },
      selectModuleIds: [],
      appModuleTreeData: [],
      gameId: '',
      resultList: [],
      gameName: '',
      gameImportConfig: {
        gameId: '',
        configJson: ''
      },
      configJsonTemplate: "示例：{\n" +
          "gameName:\"touxigua\",\n" +
          "configs:[\n" +
          "\t{\n" +
          "\t\t\"name\":\"bullet1image\",\n" +
          "\t\t\"type\":\"image\",\n" +
          "\t\t\"source\":\"xxxx.png\",\n" +
          "\t\t\"extStr\":\"\"\n" +
          "\t},\t{\n" +
          "\t\t\"name\":\"bullet1bgm\",\n" +
          "\t\t\"type\":\"mp3\",\n" +
          "\t\t\"source\":\"xxxx.mp3\",\n" +
          "\t\t\"extStr\":\"\"\n" +
          "\t},\n" +
          "\t...\n" +
          "]}",
      previewJson: ''
    }
  },
  methods: {
    getModuleTreeData() {
      api.getAppModuleTree().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.appModuleTreeData = result.data;
        }
      })
    },
    onPreviewEditorCancel() {
      this.isPreViewEditorShow = false;
    },
    onImportEditorCancel() {
      this.gameImportConfig.configJson = '';
      this.isImportEditorShow = false;
    },
    onImportEditorConfirm() {
      this.gameImportConfig.gameId = this.gameId;
      api.postImportGameConfig(this.gameImportConfig).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.onEditorCancel();
          this.$message.success(result.msg);
        } else {
          this.$message.error(result.msg);
        }
      });
    },
    showConfigPreview() {
      api.getGameConfig(this.gameId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.previewJson = JSON.stringify(JSON.parse(result.data), null, 4);
          this.isPreViewEditorShow = true;
        }
      })
    },
    showImportEditor() {
      this.isImportEditorShow = true;
    },
    uploadImage(object) {
      let formData = new FormData();
      formData.append('image', object.file);
      api.postGameImage(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '视频封面上传成功.',
            type: 'success',
            center: true
          });
          this.gameConfig.source = url;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传视频封面出错',
          type: 'error',
          center: true
        })
      })
    },
    uploadVideo(object) {
      let formData = new FormData();
      formData.append('mp4', object.file);
      api.postPubMp4(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '视频上传成功.',
            type: 'success',
            center: true
          });
          this.gameConfig.source = url;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传视频出错',
          type: 'error',
          center: true
        })
      })

    },
    uploadMp3(object) {
      let formData = new FormData();
      formData.append('mp3', object.file);
      api.postPubMp3(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '上传音频成功.',
            type: 'success',
            center: true
          });
          this.gameConfig.source = url;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传音频成功失败',
          type: 'error',
          center: true
        })
      })
    },
    deleteItem(item) {
      api.deleteGameConfig(item.id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.listContent();
        } else {
          this.$message.error(result.msg);
        }
      })
    },
    listContent() {
      api.listGameConfig(this.gameId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.resultList = result.data;
        }
      })
    },
    onEditorCancel() {
      this.gameConfig.name = '';
      this.gameConfig.source = '';
      this.gameConfig.type = '';
      this.isEditorShow = false;
    },
    onEditorConfirm() {
      if (this.gameConfig.name === '') {
        return this.$message.error("请输入配置项名称.")
      }
      if (this.gameConfig.type === '') {
        return this.$message.error("请选择配置类型.")
      }
      if (this.gameConfig.source === '') {
        return this.$message.error("请配置资源.")
      }
      this.gameConfig.moduleId = this.selectModuleIds[this.selectModuleIds.length - 1];
      this.gameConfig.gameId = this.gameId;
      if (this.gameConfig.id !== '') {
        api.updateGameConfig(this.gameConfig).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.onEditorCancel();
            this.listContent();
          } else {
            this.$message.error(result.msg);
          }
        })
      } else {
        api.postGameConfig(this.gameConfig).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$message.success(result.msg);
            this.onEditorCancel();
            this.listContent();
          } else {
            this.$message.error(result.msg);
          }
        })
      }
    },
    showEditor(item) {
      this.selectModuleIds = [];
      if (item) {
        this.gameConfig.id = item.id;
        this.gameConfig.name = item.name;
        this.gameConfig.type = item.type;
        this.gameConfig.source = item.source;
        this.gameConfig.moduleId = item.moduleId;
        this.selectModuleIds.push(item.moduleId)
        this.dialogText = '编辑游戏配置';
      } else {
        this.dialogText = '创建游戏配置';
      }
      this.isEditorShow = true;
    }
  },
  mounted() {
    this.gameId = this.$route.query.gameId;
    this.gameName = this.$route.query.gameName;
    this.listContent();
    this.getModuleTreeData()
  }
}
</script>
<style scoped>
.video-image-upload-cover {
  line-height: 240px;
  width: 240px;
  height: 240px;
}

.image-upload-cover img {
  width: 100%;
  object-fit: cover;
  height: 100%;
}

.image-upload-cover {
  text-align: center;
  cursor: pointer;
  line-height: 100px;;
  margin-right: 20px;
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: #DCDFE6 dashed 2px;
}
</style>
